import React, { useCallback, useMemo, useState } from 'react';
import InputField from '../../../components/Form/InputField';
import { colors } from '../../../colors';
import { Field, Validations } from '../../../components/Form';
import { useLoginMutation } from '../../../store/services/api';
import LoadingIcons from 'react-loading-icons';

const Loginform = ({
  handleOnboardingStart,
  handleOnboardingInProgress,
}: {
  handleOnboardingStart: () => void;
  handleOnboardingInProgress: (userId: number, onboardingStep: number) => void;
}) => {
  const [login] = useLoginMutation();

  const [email, setEmail] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  //   const [shouldRemember, setShouldRemember] = useState(false);

  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [loginError, setLoginError] = useState<string | undefined>();
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  const handleLogin = useCallback(async () => {
    if (!email || !password) {
      return;
    }

    if (!email.includes('@')) {
      setInvalidEmailError(true);
      return;
    }

    setIsLoginLoading(true);

    const data = {
      email,
      password,
    };

    const result = await login(data);

    if (result.data?.error) {
      setLoginError(result.data?.error);
    }

    if (result.data?.success && result.data?.onboardingStep) {
      handleOnboardingInProgress(
        result.data.userId,
        result.data.onboardingStep,
      );
    }

    setIsLoginLoading(false);
  }, [email, handleOnboardingInProgress, login, password]);

  const handleEmailChange = useCallback((email: string) => {
    setEmail(email);

    if (email.includes('@')) {
      setInvalidEmailError(false);
    }
  }, []);

  const emailField = useMemo<Field>(() => {
    return {
      label: 'Email',
      value: email,
      handleValueChange: handleEmailChange,
      shouldFit: true,
      error: invalidEmailError ? Validations.InvalidEmail : undefined,
    };
  }, [email, handleEmailChange, invalidEmailError]);

  const passwordField = useMemo(() => {
    return {
      label: 'Password',
      value: password,
      handleValueChange: setPassword,
      shouldFit: true,
      isSecret: true,
    };
  }, [password]);

  const disableButton = !email || !password;

  return (
    <div>
      <p
        style={{
          color: colors.white,
          fontSize: 40,
          fontWeight: 'bold',
          margin: 0,
          marginBottom: 16,
        }}
      >
        Login
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: 12 }}>
        <InputField config={emailField} />
        <InputField config={passwordField} />
      </div>

      {/* <Checkbox
        label={'Remember me?'}
        color={colors.white}
        value={shouldRemember}
        handleValueChange={setShouldRemember}
      /> */}
      {loginError && (
        <p
          style={{
            color: colors.red,
            marginTop: 4,
            margin: 0,
            marginBottom: 0,
          }}
        >
          {loginError}
        </p>
      )}
      <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
        <button
          onClick={handleLogin}
          style={{
            backgroundColor: disableButton ? colors.gray : colors.blue,
            border: `1px solid ${disableButton ? colors.gray : colors.blue}`,
            borderRadius: 4,
            cursor: disableButton ? 'default' : 'pointer',
            padding: 6,
            paddingLeft: 12,
            paddingRight: 12,
            color: colors.white,
            fontWeight: 'bold',
            textWrap: 'nowrap',
            marginTop: 16,
            fontSize: 16,
          }}
          disabled={disableButton}
        >
          {isLoginLoading ? (
            <LoadingIcons.Grid width={15} height={15} />
          ) : (
            'Login'
          )}
        </button>
      </div>
      <div
        style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}
      >
        <div
          style={{
            height: 1,
            width: '100%',
            backgroundColor: colors.gray,
            opacity: 0.3,
          }}
        />
        <span
          style={{
            color: colors.gray,
            opacity: 0.3,
            marginTop: -2,
            fontWeight: 'bold',
          }}
        >
          or
        </span>
        <div
          style={{
            height: 1,
            width: '100%',
            backgroundColor: colors.gray,
            opacity: 0.3,
          }}
        />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 2,
          cursor: 'pointer',
        }}
        onClick={handleOnboardingStart}
      >
        <span
          style={{
            color: '#304bb8',
            fontWeight: 'bold',
          }}
        >
          Register
        </span>
      </div>
    </div>
  );
};

export default Loginform;
